'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};

exports.default = getDisplayName;


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-form/lib/util/getDisplayName.js
 ** module id = 1337
 ** module chunks = 0
 **/